import styled from "styled-components";
import React, {useState} from "react";
import RadioCard from "../ui/components/form-controls/radio-card";
import propTypes from 'prop-types';
import typographyStyles from "../ui/common/typography-styles";

const RadioBoxListGroupStyle = styled.div`
    position: relative;
    width: 600x;
    height: ${props => props.big ? '164px' : '128px'};
    padding-left: 128px;
`;

const StyledRadioBoxList = styled(RadioCard)`
    height: ${props => props.big ? '132px' : '92px'};
    width: 346px;
    text-align: left;
    padding-top: 8px;
`;

const RadioBoxListLabelStyle = styled.div`
    margin-top: -6px;
    margin-left: 5px;
    margin-left: 5px;
`;

const RadioBoxListDescription = styled.div`
    ${typographyStyles({
    type: 'text',
    defaultSize: 'normal',
    defaultWeight: 'semiBold',
})}
`;

const RadioBoxListDateRange = styled.div`
    margin-top: 5px;

    ${typographyStyles({
    type: 'text',
    defaultSize: 'small',
    defaultWeight: 'normal',
})}
`;
const RadioBoxList = (props) => {
    const [selectedValue, setSelectedValue] = useState (props.value);

    const selectValue = (value) => {
        setSelectedValue(value);
        props.onClick(value);
    }

    return (
        <React.Fragment>
        {props.options.map(({value, text, dateRange}, index) =>
            <RadioBoxListGroupStyle big={props.big}>
                <StyledRadioBoxList
                    big={props.big}
                    label={
                        <RadioBoxListLabelStyle>
                            <RadioBoxListDescription>
                                {text}
                            </RadioBoxListDescription>
                            <RadioBoxListDateRange id="RadioBoxListDateRange">
                                {dateRange}
                            </RadioBoxListDateRange>
                        </RadioBoxListLabelStyle>
                    }
                    disabled={props.disabled}
                    checked={value === selectedValue}
                    onChange={() => selectValue(value)}
                />
            </RadioBoxListGroupStyle>
        )}
        </React.Fragment>
    );
}

RadioBoxList.propTypes = {
    value: propTypes.string,
    text: propTypes.string,
    dateRange: propTypes.string,
}
export default RadioBoxList;
